import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["xlink:href"];
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
import { computed } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'SvgIcon',
    props: {
        icon: {},
        src: { default: "/svg/svg-defs.svg" },
        width: { default: "1.25rem" },
        height: { default: "1.25rem" },
        color: { default: "currentColor" }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "1978c18a": (_ctx.color),
            "174ac4c4": (_ctx.width),
            "7d2a1c4f": (_ctx.height)
        }));
        const props = __props;
        const contextStore = useContext();
        const { resourceTimestamp } = storeToRefs(contextStore);
        const url = computed(() => {
            return props.src + "?ts=" + resourceTimestamp.value + "#" + props.icon;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), [
                _createElementVNode("use", {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": url.value
                }, null, 8, _hoisted_1)
            ], 16));
        };
    }
});
